import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './interseptors/auth.interceptor';
import { HttpErrorInterceptor } from './interseptors/http-error.interceptor';
import { CachingInterceptor } from './interseptors/caching.interceptor';
import { RequestCache, RequestCacheWithMap } from './services/request-cache.service';
import { MsalInterceptor } from '@azure/msal-angular';

@NgModule({
  exports: [],
  imports: [BrowserAnimationsModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: RequestCache, useClass: RequestCacheWithMap },
    { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
export class CoreModule { }
